import React from 'react';

const styles = {
  info: 'bg-info-bg text-info-foreground border-info-border',
  warning: 'bg-warning-bg text-warning-foreground border-warning-border',
  danger: 'bg-danger-bg text-danger-foreground border-danger-border',
  neutral: 'bg-prodia-background text-prodia-text-secondary border-prodia-border',
};

export default function KanbanSignalBadge({ label, variant = 'neutral' }) {
  if (!label) return null;
  return (
    <span
      className={`inline-flex items-center px-1 py-0 rounded text-[9px] font-medium border leading-none flex-shrink-0 ${styles[variant] || styles.neutral}`}
    >
      {label}
    </span>
  );
}
